
<div class="frame">
  <app-toast></app-toast>
  <form [formGroup]="blogform" class="form-container">
    <div style="flex-direction: row;display: flex;">
  <div class="col-md-6 d-flex justify-content-center align-items-center maindiv">
    <div class="upload-container text-center p-3 rounded shadow-sm mainsubdiv">
      <input #fileInput hidden type="file" formControlName="blogimg" (change)="imageInputChange($event)"/>
      <div class="upload-box" (click)="fileInput.click()">
        <ng-container *ngIf="!selectedImageUrl">
          <img src="../../../../../../assets/images/bulkupload_logo.svg" alt="Upload Banner" class="upload-icon" />
          <p class="text-muted mt-2" translate>Upload Web Image*</p>
        </ng-container>
        <ng-container *ngIf="selectedImageUrl">
          <img [src]="selectedImageUrl" alt="Selected Image" class="uploaded-image rounded" />
        </ng-container>
      </div>
    </div>
  </div>

  <div style="width: 65%;">

    <!-- <form [formGroup]="blogform" class="form-container"> -->
      <div class="formflex">
        <div class="subdiv">
          <h2 mat-dialog-title *ngIf="data?.action == 'VIEW'"><b><span translate>Blog Details</span>-{{subject}}</b></h2>
          <h2 mat-dialog-title *ngIf="data?.action == 'EDIT'"><b><span translate>Edit Blog</span>-{{subject}}</b></h2>
          <h2 mat-dialog-title *ngIf="data?.action == 'ADD'"><b><span translate>Add Blog</span></b></h2>
        </div>
        <div>
          <button matIconButton (click)="dialogRef.close()" style="float: right;"
            aria-label="Example icon button with a vertical three dot icon">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="data?.action != 'VIEW'" class="formflex">
        <div class="subdiv">
          <div class="align">
            <label
              [ngClass]="blogform.get('title')?.touched && blogform.get('title')?.invalid ? 'active-class' : 'inactive-class'" translate>Title*</label>
          </div>
          <div class="align">
            <input
              [ngClass]="blogform.get('title')?.touched && blogform.get('title')?.invalid ? 'title-active' : 'title-inactive'"
              type="text" formControlName="title"/>
          </div>
          <div class="align" *ngIf="blogform.get('title')?.touched && blogform.get('title')?.invalid">
            <small
              [ngClass]="blogform.get('title')?.touched && blogform.get('title')?.invalid ? 'active-class' : 'inactive-class'" translate>Title is required.</small>
          </div>
        </div>
      </div>
      <div *ngIf="data?.action == 'VIEW'">
        <div class="formflex">
          <span class="viewwidth" translate>Title</span> <span class="viewwidth1">:</span> <span
            class="viewwidth">{{subject}}</span>
        </div>
        <div class="formflex">
          <span class="viewwidth" translate>Is Publish</span> <span class="viewwidth1">:</span> <span class="viewwidth">{{publish
            == false ? 'No' : 'Yes'}}</span>
        </div>
        <div class="formflex">
          <span class="viewwidth" translate>Publish Date</span> <span class="viewwidth1">:</span> <span
            class="viewwidth">{{publish_dt | date:'dd/MM/yyyy'}}</span>
        </div>
      </div>
      <div class="subdiv">
        <div class="align">
          <label
            [ngClass]="blogform.get('content')?.touched && blogform.get('content')?.invalid ? 'active-class' : 'inactive-class'" translate>Content*</label>
        </div>
        <quill-editor formControlName="content"
          [ngClass]="blogform.get('content')?.touched && blogform.get('content')?.invalid ? 'editor-active' : 'editor-inactive'"
          placeholder="Enter Content..." [modules]="quillConfig" (onSelectionChanged)="onSelectionChanged($event)"
          (onContentChanged)="onContentChanged($event)">
        </quill-editor>
        <div class="align" *ngIf="blogform.get('content')?.touched && blogform.get('content')?.invalid">
          <small
            [ngClass]="blogform.get('content')?.touched && blogform.get('content')?.invalid ? 'active-class' : 'inactive-class'" translate>Content
            is required.</small>
        </div>
      </div>

      <div class="subdiv">
        <button mat-stroked-button color="primary" *ngIf="data?.action == 'VIEW'" class="button"
          (click)="dialogRef.close()" translate>Cancel</button>
        <button mat-raised-button *ngIf="data?.action != 'VIEW'" color="primary" class="button"
          (click)="submitDialog()" translate>Submit</button>
      </div>
    <!-- </form> -->
  </div>
  </div>
  </form>
</div>
